import { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getAllPlacementSpoc } from '../../../services/apiService';
import { getFullName } from '../../../utils';

const useFilterPlacementSpoc = () => {
  const { user } = useSelector((state) => state.userReducer);
  const [placementSpocOptions, setplacementSpocOptions] = useState([]); // dropdown options data
  const [placementSpocFilter, setPlacementSpocFilter] = useState([]); // array of spoc ids
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // fetching Placement Spocs
  const fetchPlacementSpocs = useCallback(async () => {
    try {
      const response = await getAllPlacementSpoc();

      const options = response?.data?.map(
        ({ placementSpocDetails, placementSpocId }) => ({
          key: placementSpocDetails.id,
          text: getFullName(placementSpocDetails),
          value: placementSpocId,
          image: {
            avatar: true,
            src: placementSpocDetails.thumbnail,
          },
        })
      ); // mapping the data for Semantic UI Dropdown Componet's options prop
      setplacementSpocOptions(options);
      setLoading(false);
    } catch (error) {
      console.log({ error });
      setError(error.message);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPlacementSpocs();
  }, [fetchPlacementSpocs]);

  useEffect(() => {
    if (user?.id) {
      setPlacementSpocFilter([user.id]);
      setLoading(false);
    }
  }, [user]);

  return {
    loading,
    error,
    placementSpocOptions,
    placementSpocFilter,
    setPlacementSpocFilter,
  };
};

export default useFilterPlacementSpoc;
